// extracted by mini-css-extract-plugin
export default {"edkButtons":"UserEdk_edkButtons__fevwp"};